import { get, post } from "../../../../services/request";

// Get Site Details by ID
export const getSiteDetailsById = (siteId) => {
  return get(`SiteManagement/GetSiteDetailsByID?SiteID=${siteId}`);
};

// Get Zipcode Details by Zipcode
export const getZipcodeDetailsByZipcode = (zipcode) => {
  return get(`Common/GetCityStateByZipCode?ZipCode=${zipcode}`);
};
// Save Site Details
export const saveSiteDetails = (siteData) => {
  return post("SiteManagement/SaveSiteDetails", siteData);
};

// Save Priority SLA
export const savePrioritySla = (prioritySlaData) => {
  return post("SiteManagement/SaveSitePrioritySLA", prioritySlaData);
};

// Save Site Tags
export const saveSiteTags = (payload) => {
  return post("SiteManagement/SaveSiteTags", payload);
};

// Get Sister Sites by Site ID
export const getSisterSitesBySiteId = (siteId) => {
  return get(`SiteManagement/GetAllSisterSitesBySiteID?SiteID=${siteId}`);
};

// Get Site Alias by Site ID
export const getSiteAliasBySiteId = (siteId) => {
  return get(`SiteAliasDetail/GetSiteAliasDetailBySiteID?SiteID=${siteId}`);
};

// Get Site Alias History by Site Alias Detail ID
export const getSiteAliasHistoryById = (siteAliasDetailId) => {
  return get(
    `SiteAliasDetail/GetSiteAliasDetailHistoryByID?SiteAliasDetailID=${siteAliasDetailId}`,
  );
};

// Save Site Alias Detail
export const saveSiteAliasDetail = (siteAliasData) => {
  return post("SiteAliasDetail/SaveSiteAliasDetail", siteAliasData);
};

// Get All Site Model Input Files
export const getAllSiteModelInputFiles = (siteId) => {
  return get(`SiteModelInput/GetAllSiteModelInputFile?id=${siteId}`);
};

// Download Site Model Input Template
export const downloadSiteModelInputTemplate = (siteModelInputFileName) => {
  return get(
    `SiteModelInput/DownloadSiteModelInputTemplate?siteModelInputFileName=${siteModelInputFileName}`,
  );
};

// Upload Site Model Input File (multipart/form-data)
export const uploadSiteModelInputFile = (file, siteId, createdBy) => {
  const formData = new FormData();
  // file should be a File object, include the filename
  formData.append("file", file, file.name || "upload.xlsx");
  // API expects ApiRequestString as JSON string with numeric types
  const apiRequestString = JSON.stringify({
    SiteId: parseInt(siteId, 10),
    CreatedBy: parseInt(createdBy, 10),
  });
  formData.append("ApiRequestString", apiRequestString);
  return post("SiteModelInput/SiteModelInputFileUpload", formData);
};

// Fetch overall priority/modality mix and related pivot data
export const getAllSiteModelFilter = (payload) => {
  // payload is expected to be a JS object matching API contract
  return post("SiteModelInput/GetAllSiteModelFilter", payload);
};

// Save Site Model Input
export const saveSiteModelInput = (payload) => {
  // payload expected: { SiteID: string, lstSiteModelInputData: [...], CreatedBy: number }
  return post("SiteModelInput/SaveSiteModelInput", payload);
};

// Get Priority / Subspeciality Split by SiteID
export const getPrioritySubspecialitySplitBySiteId = (siteId) => {
  return get(
    `SiteModelInput/GetPrioritySubspecialitySplitBySiteId?SiteId=${siteId}`,
  );
};

// Check Priority / Subspeciality Config Availability by SiteID
export const checkPrioritySubspecialityConfigBySiteId = (payload) => {
  return get(
    `SiteModelInput/Check_PrioritySubSpecialityConfig_BySiteId?SiteID=${payload.SiteID}`,
  );
};

// Save Priority / Subspeciality Split
export const savePrioritySubspecialitySplits = (payload) => {
  return post("SiteModelInput/SavePrioritySubspecialitySplits", payload);
};

// Enable or Disable Sister Site
export const enableDisableSisterSite = (payload) => {
  // payload: { SisterSiteID, Status, sisterSiteName, ModifiedBy }
  return post("SiteManagement/EnableDisableSisterSite", payload);
};

// Get Sister Site History by SisterSiteID
export const getSisterSiteHistory = (sisterSiteId) => {
  return get(
    `SiteManagement/GetAllSisterSiteHistory?SisterSiteID=${sisterSiteId}`,
  );
};

// Get Site Onboarding Details by SiteOnboardingID
export const getSiteOnboardingDetailsByID = (SiteOnboardingID) => {
  return get(
    `SiteOnboardingPlanner/GetRequestedSitesDetailsById?id=${SiteOnboardingID}`,
  );
};

// Get State list
export const getStateList = () => {
  return get("State/GetAllState");
};

// Update site scheduling state
export const updateSiteState = (siteId, stateId) => {
  return post("Site/UpdateState", { SiteID: siteId, StateID: stateId });
};
